import * as moment from 'moment'
import * as React from 'react'
import { convertCentsToDollars } from 'src/utils'
import { SERVICE_LIST_TYPE } from '../../../../state/constants/index'
import { IMap, IMembershipObject, IRiderObject, IServiceObject, IStateMetadata } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import RiderBottomBar from '../EditRiderBottomBar'
import MembershipListItem from './MembershipListItem'
import FloatingForm from 'src/components/ui/form/FloatingForm'

interface IMembershipPaneProps {
  memberships: IMap<IMembershipObject>
  metadata: IStateMetadata
  orgId: string
  rider: IRiderObject
  riderId: string
  services: IMap<IServiceObject>
  getMembershipList: (riderId: string, orgId: string) => void
  getServiceList: (type: string, orgId: string) => void
  saveMembership: (rider: IRiderObject, memberships: IMembershipObject[]) => void
  showMessage: (error: string, isError: boolean) => void
}

export interface IMembershipSpecialObject extends IMembershipObject {
  selected: boolean
}

interface IMembershipPaneState {
  isSaved: boolean
  isSaving: boolean
  selected: IMembershipSpecialObject[]
}

class MembershipPane extends React.Component<IMembershipPaneProps, IMembershipPaneState> {
  constructor(props: any) {
    super(props)
    this.state = {
      isSaved: true,
      isSaving: false,
      selected: []
    }
    this.props.showMessage('', false)
  }

  public componentDidMount() {
    this.props.getMembershipList(this.props.riderId, this.props.orgId)
    this.props.getServiceList(SERVICE_LIST_TYPE.ACTIVE, this.props.orgId)
    if (this.props.services && Object.keys(this.props.services).length > 0) {
      this.setPropsToState()
    }
  }

  public componentDidUpdate(prevProps: IMembershipPaneProps) {
    if (JSON.stringify(this.props.services) !== JSON.stringify(prevProps.services)) {
      this.setPropsToState()
    }
    if (prevProps.metadata !== this.props.metadata) {
      const { processingError, processingSuccess } = this.props.metadata
      if (processingError) {
        this.setState({ isSaving: false, isSaved: false })
      }
      if (processingSuccess) {
        this.setState({ isSaving: false, isSaved: true })
      }
    }
  }

  public render() {
    const { services } = this.props
    const bodyStyle: any = {
      pointerEvents: this.state.isSaving ? 'none' : 'auto',
      opacity: this.state.isSaving ? 0.4 : 1.0
    }

    return (
      <section>
        <FloatingForm fullHeight={true}>
          <div className='form-modal-section main-section'>
            <div>
              {this.state.selected &&
                Object.values(this.state.selected).map((item: IMembershipSpecialObject, i) => {
                  return (
                    <div className={'MembershipItem' + i} key={`tmli-${i}`}>
                      {
                        <MembershipListItem
                          onUpdate={this.onUpdateMembership}
                          membership={item}
                          service={item.service ? item.service : ({} as IServiceObject)}
                        />
                      }
                    </div>
                  )
                })}
            </div>
          </div>
        </FloatingForm>
        <RiderBottomBar
          cancelPath={this.props.riderId ? `/riders/${this.props.riderId}/profile/membership` : '/riders'}
          isSaving={this.state.isSaving}
          onSave={this.onSave}
        />
      </section>
    )
  }

  private onUpdateMembership = (membership: IMembershipSpecialObject) => {
    const selected = this.state.selected.map((it: any) => {
      if (it.service === membership.service) {
        return membership
      }
      return it
    })
    this.setState(
      {
        selected,
        isSaved: false
      },
      () => {
        // Refresh the membership and service lists after updating
        this.props.getMembershipList(this.props.riderId, this.props.orgId)
        this.props.getServiceList(SERVICE_LIST_TYPE.ACTIVE, this.props.orgId)
      }
    )
  }

  private onSave = () => {
    // Mini-validation: Check if a recurring membership has any months
    for (const membership of this.state.selected) {
      if (membership.selected && membership.isLimitedByRecurringMonths && membership.recurringMonths.length === 0) {
        this.props.showMessage(UIMessages.rider.validation.membershipRecurringMonthsMinLength, true)
        return
      }
    }

    const selected: IMembershipObject[] = this.state.selected.filter((it: any) => it.selected)
    this.setState({ isSaving: true })
    this.props.saveMembership(this.props.rider, selected)

    // Refresh the membership and service lists after saving
    this.setState({ isSaving: false, isSaved: true }, () => {
      this.props.getMembershipList(this.props.riderId, this.props.orgId)
      this.props.getServiceList(SERVICE_LIST_TYPE.ACTIVE, this.props.orgId)
    })
  }

  private setPropsToState = () => {
    const memberships = Object.values(this.props.memberships)
    const selected: IMembershipSpecialObject[] = Object.values(this.props.services).map((it: IServiceObject, index) => {
      const membership = memberships.find((it2: any) => it2.service.id === it.id)
      if (membership) {
        const beginsAt = membership.beginsAt ? moment(membership.beginsAt) : moment()
        const expiresAt = membership.expiresAt ? moment(membership.expiresAt) : moment().add(1, 'days')
        return {
          ...membership,
          selected: true,
          beginsAt,
          expiresAt
        }
      }
      return {
        service: it,
        serviceId: it.id,
        type: 'PERMANENT',
        notAllowedPCA: it.notAllowedPCA,
        isLimitedByDate: false,
        requestedAt: new Date(),
        // beginsAt: new Date(),
        // expiresAt: moment()
        //   .add(1, 'days')
        //   .toDate(),
        beginsAt: moment(),
        expiresAt: moment().add(1, 'days'),
        isLimitedByRecurringMonths: false,
        recurringMonths: [],
        isLimitedByNumberOfRides: false,
        ridesRangeType: 'Week',
        ridesNum: 1,
        selected: false,
        isSuspended: false,
        suspensionUntil: new Date()
      }
    })
    this.setState({ selected })
  }
}

export default MembershipPane



// WEBPACK FOOTER //
// ./src/components/riders/editrider/membership/MembershipPane.tsx